import React from 'react';

const EmptyState = () => {
  return (
    <div className="empty-state">
      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          strokeWidth="2" 
          d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z"
        />
      </svg>
      <h2>No Bookmarks Yet</h2>
      <p>Your bookmarked queries will appear here</p>
    </div>
  );
};

export default EmptyState;